function SeasideLogo() {
  return (
    <img
      height="200"
      width="200"
      src="/logos/seaside-logo.png"
      className="w-full h-full object-contain"
      alt="Seaside Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { SeasideLogo };
